import { createMMKV } from "react-native-mmkv"
import { Dimensions } from "react-native"

export const storage = createMMKV()
export const queryStorage = createMMKV()

export const WINDOW = Dimensions.get("screen")

export function setToken(token: string) {
  return storage.set("token", token)
}

export function getToken() {
  return storage.getString("token")
}
